import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { RecipesRoot } from './Recipes.styles'
import { Hero } from './Overview/components/Hero'
import { SelectRecipe } from './Overview/components/SelectRecipes'
import hero from '../../../public/assets/recipes/overview/freeze-dried/freeze-dried-raw-recipe-hero.webp'
import { FeedBetter } from './Overview/components/FeedBetter'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { Footer } from 'components/Footer'
import { MadeRight } from './Overview/components/MadeRight/MadeRight'
import { HowItWorks } from './Overview/components/HowItWorks'
import { StatsSpeak } from '../WhyWeFeedRaw/components/StatsSpeak'
import { FloatingCta } from './Overview/components/FloatingCta'
import freezeDriedChickenHalf from '../../../public/assets/recipes/freezeDried/freeze-dried-half-bowl-chicken.webp'

export const FreezeDriedRecipes = () => {
  const { t } = useTranslation()
  const header = <Header />

  return (
    <RecipesRoot>
      <Layout hideCTA header={header}>
        <Hero
          title={t('recipes-overview:hero.freeze-dried.title')}
          subtitle={t('recipes-overview:hero.freeze-dried.subtitle')}
          heroImage={hero}
          imageAlt={t('recipes-overview:hero.freeze-dried.image-alt')}
        />
        <SelectRecipe type="freeze-dried" />
        <MadeRight type="freeze-dried" />
        <HowItWorks image={freezeDriedChickenHalf} />
        <StatsSpeak background="accent-white" />
        <FeedBetter showFrozen={true} showFreezeDried={false} />
        <CtaFooter title="why-we-feed-raw:footer.title" hideSecondaryCta />
        <FloatingCta />
        <Footer />
      </Layout>
    </RecipesRoot>
  )
}

FreezeDriedRecipes.displayName = 'FreezeDriedRecipes'
